const CustomerTagModule = () => import('./CustomerTagModule.vue')
const CustomerTagIndex = () => import('./views/CustomerTagIndex.vue')

export const customerTagRoute = {
  path: '/customer-tags',
  name: 'customerTag',
  component: CustomerTagModule,
  meta: {
    title: 'Customer Tags',
    requiresAuth: true,
    keepAlive: true,
  },
  children: [
    {
      path: '',
      name: 'customer-tags-index',
      meta: {
        permission: 'customer-tags.view',
      },
      component: CustomerTagIndex,
    },
  ],
}
